export default __webpack_public_path__ + "static/media/pattern.0903ca80.svg";